import type { Control } from 'react-hook-form';
import { Controller } from 'react-hook-form';
import type { ParticipantRowProps } from './ParticipantsRow';
import { ParticipantRow } from './ParticipantsRow';
import type { FormData } from './types/form-data';

export type ControlledParticipantRowProps = Omit<
  ParticipantRowProps,
  'participant' | 'onChange' | 'onBlur'
> & {
  control: Control<FormData>;
  index: number;
};

export const ControlledParticipantRow = ({
  disabled,
  onRemoveParticipantsClick,
  control,
  index,
}: ControlledParticipantRowProps) => {
  return (
    <Controller
      control={control}
      name={`newParticipants.${index}`}
      render={({ field: { value, onChange, onBlur } }) => {
        return (
          <ParticipantRow
            participant={value}
            disabled={disabled}
            onRemoveParticipantsClick={onRemoveParticipantsClick}
            onChange={onChange}
            onBlur={onBlur}
          />
        );
      }}
    />
  );
};
